<template>
  <div
    class="flex cursor-pointer items-center gap-2.5 rounded-md px-2.5 py-2 transition-colors duration-100 outline-none"
    :class="[
      destructive
        ? 'text-danger-600 hover:bg-danger-50 focus-visible:bg-danger-50'
        : 'text-content hover:bg-selected focus-visible:bg-selected [&_svg]:text-content-muted hover:[&_svg]:text-content',
      { 'cursor-not-allowed! opacity-50': disabled },
    ]"
    :data-test="data_test"
    :role="role"
    tabindex="0"
    :aria-disabled="disabled ? 'true' : 'false'"
    :aria-describedby="reason_visible ? reason_id : null"
    v-bind="$attrs"
    v-tooltip.left="{ value: tooltip }"
    @click="onClick"
    @keydown.enter.prevent="onClick"
    @keydown.space.prevent="onClick"
  >
    <slot />
    <span
      v-if="reason_visible"
      :id="reason_id"
      class="sr-only"
      aria-hidden="true"
    >
      {{ tooltip }}
    </span>
  </div>
</template>

<script setup>
import { computed, inject, useId } from 'vue';
import INJECT_KEYS from '@/app/data/inject_keys';

const emit = defineEmits(['click']);

const props = defineProps({
  data_test: { type: String, default: '' },
  disabled: { type: Boolean },
  role: { type: String, default: 'menuitem' },
  keep_open: { type: Boolean },
  tooltip: { type: String, default: null },
  destructive: { type: Boolean },
});

const dropdownHide = inject(INJECT_KEYS.DROPDOWN_HIDE, null);

const reason_id = useId();
const reason_visible = computed(() => props.disabled && Boolean(props.tooltip));

const onClick = () => {
  if (props.disabled) return;
  emit('click');
  if (!props.keep_open && dropdownHide) {
    dropdownHide();
  }
};
</script>
